import { isUuid } from '@/lib/validation';
import type { ServiceClient } from '../http/client';
import { invalidPresentation } from './native-presentation';
export const devicePurposes = {
  UNKNOWN: '용도 미확인',
  COMMON_ENTRANCE: '공동현관',
  ROOM_LOCK: '객실문',
} as const;
export type DevicePurpose = keyof typeof devicePurposes;
export interface PurposeContext {
  core_device_id: string;
  revision: number;
  purpose: DevicePurpose;
  command_property_ids: string[];
  requires_property_selection: boolean;
  last_change_actor_id: string | null;
  last_change_reason: string | null;
}
export interface PurposeBody {
  command_id: string;
  property_id: string;
  expected_revision: number;
  purpose: DevicePurpose;
  reason: string;
}
export async function readPurpose(client: ServiceClient, id: string, propertyId?: string) {
  const v = await client.get<PurposeContext | null>(`admin/access-devices/${id}/command-context`, {
    params: { property_id: propertyId },
    headers: { 'Cache-Control': 'no-store' },
  });
  if (
    !v ||
    typeof v !== 'object' ||
    Object.keys(v).length !== 7 ||
    v.core_device_id !== id ||
    !Number.isSafeInteger(v.revision) ||
    v.revision <= 0 ||
    typeof v.purpose !== 'string' ||
    !(v.purpose in devicePurposes) ||
    !Array.isArray(v.command_property_ids) ||
    !v.command_property_ids.every(isUuid) ||
    typeof v.requires_property_selection !== 'boolean' ||
    !(v.last_change_actor_id === null || isUuid(v.last_change_actor_id)) ||
    !(v.last_change_reason === null || typeof v.last_change_reason === 'string')
  )
    throw invalidPresentation();
  return v;
}
export async function writePurpose(client: ServiceClient, id: string, body: PurposeBody) {
  const v = await client.put<null | {
    command_id: string;
    device_id: string;
    purpose: DevicePurpose;
    result_revision: number;
    effect: string;
    received_at: string;
  }>(`admin/access-devices/${id}/purpose`, { json: body });
  if (
    !v ||
    Object.keys(v).length !== 6 ||
    v.command_id !== body.command_id ||
    v.device_id !== id ||
    v.purpose !== body.purpose ||
    !Number.isSafeInteger(v.result_revision) ||
    v.result_revision <= 0 ||
    !['CHANGED', 'NO_CHANGE'].includes(v.effect) ||
    typeof v.received_at !== 'string'
  )
    throw invalidPresentation();
}
